module.exports = __webpack_public_path__ + "img/four3Green.855f5fc1.png";